import Logo from '@images/brand/hi-marley-logo-red-on-light.svg';

const MarleyIcon = () => <Logo width={91} height={24} />;

export default MarleyIcon;
